import React, { forwardRef, useImperativeHandle } from 'react';
import { DateInput, FieldProps, useInput } from 'react-admin';
import { useTranslate } from 'react-admin';
export interface DateRangeProps extends FieldProps {
  source: string;
  startLabel?: string;
  endLabel?: string;
}

export interface DateRangeRef {
  reset: () => void;
}

// eslint-disable-next-line react/display-name
const DateRangeField = forwardRef<DateRangeRef, DateRangeProps>(
  ({ source, startLabel: startLabelKey, endLabel: endLabelKey }, ref) => {
    const startInput = useInput({ source: `${source}_start` });
    const endInput = useInput({ source: `${source}_end` });

    useImperativeHandle(ref, () => ({
      reset: () => {
        startInput.input.onChange(undefined);
        endInput.input.onChange(undefined);
      },
    }));

    const startValue = startInput.input.value as string | undefined;
    const endValue = endInput.input.value as string | undefined;
    const t = useTranslate();

    let startLabel = t('resource.missions.field.begin_at.label');
    let endLabel = t('resource.milestones.field.end_date.label');

    if (startLabelKey && endLabelKey) {
      startLabel = t(startLabelKey);
      endLabel = t(endLabelKey);
    } else if (source === 'billing_date') {
      startLabel = t('resource.invoices.field.billing_date_start.label');
      endLabel = t('resource.invoices.field.billing_date_end.label');
    } else if (source === 'payment_date') {
      startLabel = t('resource.invoices.field.payment_date_start.label');
      endLabel = t('resource.invoices.field.payment_date_end.label');
    } else if (source === 'created_at') {
      startLabel = t('resource.users.field.created_at_start.label');
      endLabel = t('resource.users.field.created_at_end.label');
    } else if (source === 'last_signin_at') {
      startLabel = t('resource.users.field.last_signin_at_start.label');
      endLabel = t('resource.users.field.last_signin_at_end.label');
    } else if (source === 'updated_at') {
      startLabel = t('resource.users.field.updated_at_start.label');
      endLabel = t('resource.users.field.updated_at_end.label');
    }

    return (
      <div style={{ marginBottom: '-20px' }}>
        <DateInput
          label={startLabel}
          source={`${source}_start`}
          {...startInput}
          inputProps={{ max: endValue }}
        />
        <DateInput
          label={endLabel}
          source={`${source}_end`}
          {...endInput}
          inputProps={{ min: startValue }}
        />
      </div>
    );
  }
);

export default DateRangeField;
